import { useState, useEffect, useRef } from 'react';

export default function SystemsWeBuild() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const systems = [
    {
      icon: 'ri-settings-3-line',
      title: 'Hệ thống quản lý nghiệp vụ đặc thù',
      description: 'Giải pháp tùy chỉnh cho quy trình riêng biệt'
    },
    {
      icon: 'ri-organization-chart',
      title: 'CRM, ERP, HRM theo yêu cầu',
      description: 'Hệ thống quản lý phù hợp với doanh nghiệp'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Nền tảng SaaS, hệ thống đa người dùng',
      description: 'Xây dựng sản phẩm phần mềm có thể mở rộng'
    },
    {
      icon: 'ri-links-line',
      title: 'Hệ thống tích hợp nhiều phần mềm',
      description: 'Kết nối và đồng bộ dữ liệu giữa các hệ thống'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Ứng dụng phục vụ chuyển đổi số',
      description: 'Số hóa quy trình và tối ưu vận hành'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 right-20 w-72 h-72 bg-[#06b6d4]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-72 h-72 bg-[#00c897]/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2a4b7c] mb-6" style={{ lineHeight: '1.2' }}>
            STACKWAY PHÁT TRIỂN<br />NHỮNG HỆ THỐNG NÀO?
          </h2>
          <div className={`w-20 h-1 bg-[#00c897] mx-auto transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`} style={{ transformOrigin: 'center' }}></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {systems.map((system, index) => (
            <div
              key={index}
              className={`group bg-white p-8 rounded-2xl border border-gray-200 hover:border-[#06b6d4] transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${600 + index * 100}ms` }}
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#06b6d4]/10 to-[#00c897]/10 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${system.icon} text-3xl text-[#06b6d4]`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-[#2a4b7c] mb-3 leading-tight">
                {system.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed">
                {system.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}